import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { toast } from "react-toastify";
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { MultiSelect } from "primereact/multiselect";
import { useGetEDSCompAssignmentsQuery, useCreateEDSCompAssignmentMutation, useDeleteEDSCompAssignmentMutation } from "./edsCompAssignmentSlice";
import { GetLinkLevelData, GetRoleData, exportExcel } from "./edsCompAssignment-service";
//import { selectCurrentEmpid } from "../../pages/login/authSlice";
import "./edsCompAssignment.scss";
import { DateTemplate } from "../dateTemplate/DateTemplate";
import { selectCurrentEmpid } from "../../pages/login/authSlice";

type EDSCompAssignmentProps = {
    agentNumber: number;
    agentName: string;
    scorecardId?: number;
    parentClientId?: number;
}
// eslint-disable-next-line max-statements
const EDSCompAssignment = ({ agentNumber, agentName, scorecardId, parentClientId }: EDSCompAssignmentProps) => {
    const [selectedLinkLevel, setSelectedLinkLevel] = useState<string>();
    const [selectedRole, setSelectedRole] = useState<string>('');
    const [CreateAssignment] = useCreateEDSCompAssignmentMutation();
    const [DeleteAssignment] = useDeleteEDSCompAssignmentMutation();
    const [selectedAssignments, setSelectedAssignments] = useState<any>([]);
    const [assignmentsViewData, setAssignmentsViewData] = useState<any>([]);
    const [roles, setRoles] = useState<any[]>();

    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const loggedUser = useSelector(selectCurrentEmpid);
    const [filters, setFilters] = useState<any>();

    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        // @ts-ignore
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };
    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            'employee_name': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            'parent_client_name': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            'scorecard_name': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            'application_role_name': { value: null, matchMode: FilterMatchMode.IN },
            'create_date': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
        });
        setGlobalFilterValue('');
    };
    const clearFilter = () => {
        initFilters();
    };
    useEffect(() => {
        initFilters();
    }, []);
    const { data: scAssignmentsViewData } = useGetEDSCompAssignmentsQuery({});
    const processData = (data: any) => {
        return data.map((item: any) => {
            let parentClientName = item.parent_client_name;
            let scorecardName = item.scorecard_name;
            if(parentClientName === '--' && scorecardName === '--') {
                parentClientName = 'All';
                scorecardName = 'All';
            }
            return {
                ...item,
                "parent_client_name": parentClientName,
                "scorecard_name": scorecardName,
                "create_date": new Date(item.create_date),
            };
        });
    }
    useEffect(() => {
        if (scAssignmentsViewData?.data?.length > 0) {
            const data = processData(scAssignmentsViewData?.data);
            setAssignmentsViewData(data);
            const distRoles = Array.from(
                new Set(scAssignmentsViewData?.data.map((item: any) => item.application_role_name))
            );
            setRoles(distRoles);
        }
        else {
            setAssignmentsViewData([]);
            setRoles([]);
        }
    }, [scAssignmentsViewData]);

    useEffect(() => {
        if (selectedRole === 'comp')
            setSelectedLinkLevel('global');
    }, [selectedRole]);
    const onClickAssign = () => {
        let role = 0;
        const linkLevel = selectedLinkLevel;
        if (!agentNumber) {
            toast.warn('Please select Employee from associate lookup.');
            return;
        }
        if (selectedRole === undefined || selectedRole === null || selectedRole === '') {
            toast.warn('Please select Role');
            return;
        }
        else if (selectedRole === 'eds' || selectedRole === 'comp') {
            role = selectedRole === 'eds' ? 5 : 4;
        }
        if (linkLevel === undefined || linkLevel === null || linkLevel === '') {
            toast.warn('Please select Link Level');
        }
        else if (linkLevel === 'scorecard' && typeof scorecardId !== 'number') {
            toast.warn('Please select scorecard');
        }
        else if (linkLevel === 'parentclient' && typeof parentClientId !== 'number') {
            toast.warn('Please select parent client');
        }
        else {
            const data = {
                "employee_number": agentNumber,
                "application_role_id": role,
                "parent_client_id": linkLevel === 'parentclient' ? parentClientId : null,
                "scorecard_id": linkLevel === 'scorecard' ? scorecardId : null,
                "created_by": loggedUser,
            };
            CreateAssignment(data)
                .unwrap()
                .then((response: any) => {
                    if (response.data.includes("successfully"))
                        toast.success(response.data);
                    else if (response.data.includes("Error"))
                        toast.error("Error in assigning");
                    else
                        toast.info(response.data);
                })
                .then((error: any) => {
                    toast.error(error);
                });
        }
    }
    const onClickDelete = () => {
        if (selectedAssignments.length > 0) {
            const assignmentIds = selectedAssignments.map((item: any) => item.scorecard_management_assign_id);
            DeleteAssignment({scManagementAssignIds:assignmentIds,employeeNumber:loggedUser})
                .unwrap()
                .then(() => {
                    const msg = selectedAssignments.length > 1 ? "Assignments" : "Assignment";
                    toast.success(msg + " deleted successfully.");
                    setSelectedAssignments([]);
                })
                .then((error: any) => {
                    toast.error(error);
                });
        }
        else {
            toast.warn("Please select assignments to delete");
        }
    }
    const renderHeader = () => {
        return (
            <div className="exportexcel">
                <Divider />
                <Button type="button" icon="pi pi-filter-slash" className='btn-primary' label="Clear" onClick={clearFilter} />
                <span className="p-input-icon-left ms-3">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                    />
                </span>
                <Button type="button" label="Delete" className="btn-primary me-4 float-end"
                    disabled={selectedAssignments?.length <= 0} onClick={onClickDelete} />
                <Button
                    type="button"
                    icon="pi pi-upload me-2"
                    className="btn-export mr-2 me-2 float-end"
                    // style={{ backgroundColor: '#007bff', color: '#fff' }}
                    onClick={() => {
                        exportExcel(assignmentsViewData);
                    }}
                    data-pr-tooltip="XLS"
                >
                    Export All
                </Button>
            </div>
        );
    };
    const dateOnchanges = (e: any, options: any) => {
        options.filterCallback(e.value, options.index);
    }
    const dateBodyTemplate = (rowData: any) => {
        return DateTemplate(rowData.create_date);
    };
    const dateFilterTemplate = (options: any) => {
        return <Calendar value={options.value} onChange={(e: any) => dateOnchanges(e, options)}
            dateFormat="mm/dd/yy"
            placeholder="dd/mm/yy"
            mask="99/99/9999" 
            showIcon
            className="custom-calendar"/>;
    };
    const RoleFilterOnChange = (options: any, e: any) => {
        options.filterCallback(e.value);
    }
    const roleFilterTemplate = (options: any) => {
        return <MultiSelect value={options.value} options={roles} onChange={(e: any) => { RoleFilterOnChange(options, e) }} placeholder="Any" className="p-column-filter" />;
    };
    const onSelectionChange = (event: any) => {
        setSelectedAssignments(event.value);
    };
    const header = renderHeader();
    return (
        <div className="card mt-3 ms-0 me-0 shadow bg-body rounded border-0">
            <div className="row mt-4 ms-2">
                <div className="col-md-3">
                    <h6 style={{ fontWeight: '600', fontSize: '16px', }}>
                        Analyst(copied from above)
                    </h6>
                    <span>{agentName}</span>
                </div>
                <div className="col-md-3">
                    <h6 style={{ fontWeight: '600', fontSize: '16px', }}>
                        Assign to Role
                    </h6>
                    <Dropdown value={selectedRole} onChange={(event) => { setSelectedRole(event.target.value); }}
                        options={GetRoleData()}
                        optionLabel={'name'} optionValue={'code'}
                        placeholder="Select" className="custom-dropdown" />
                </div>
                <div className="col-md-4">
                    <h6 style={{ fontWeight: '600', fontSize: '16px', }}>
                        Link Level(will copy from filters above)
                    </h6>
                    <Dropdown value={selectedLinkLevel} onChange={(event) => { setSelectedLinkLevel(event.target.value); }}
                        options={GetLinkLevelData(selectedRole)}
                        optionLabel={'name'} optionValue={'code'}
                        placeholder="Select" className="custom-dropdown" />
                </div>
            </div>
            <div className="row m-2">
                <div className="col-md-12">
                    <Button type="button" label="Assign" className="btn-primary me-4 float-end"
                        onClick={onClickAssign} />
                </div>
            </div>
            <div className="card-body p-0 align-middle text-center table">
                <DataTable
                    value={assignmentsViewData}
                    header={header}
                    dataKey="scorecard_management_assign_id"
                    className="assignmentTable"
                    scrollable
                    scrollHeight="600px"
                    globalFilterFields={['employee_name', 'parent_client_name', 'scorecard_name', 'create_date', 'application_role_name']}
                    filters={filters}
                    rows={5}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    paginator={assignmentsViewData?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    selectionMode={undefined} selection={selectedAssignments}
                    onSelectionChange={onSelectionChange}
                >
                    <Column key="check" selectionMode="multiple" style={{ maxWidth: '3rem' }}
                        filterMenuStyle={{ width: '3em' }} />
                    <Column
                        header="Employee"
                        field="employee_name"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="employee_name" filter
                        filterField="employee_name"
                    />
                    <Column
                        header="Parent Client"
                        field="parent_client_name"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="parent_client_name"
                        filter filterPlaceholder="Search by Parent Client"
                    />
                    <Column
                        header="Scorecard"
                        field="scorecard_name"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="scorecard_name"
                        filter filterPlaceholder="Search by Scorecard"
                    />
                    <Column
                        header="Date Assigned"
                        field="create_date"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        body={dateBodyTemplate}
                        sortField="create_date"
                        filter filterPlaceholder="Search by Assigned Date" dataType="date" filterElement={dateFilterTemplate}
                    />
                    <Column
                        header="Role"
                        field="application_role_name"
                        sortable
                        sortField="application_role_name"
                        style={{ minWidth: '13rem' }}
                        filterField="application_role_name" showFilterMatchModes={false}
                        filter filterElement={roleFilterTemplate}
                    />
                </DataTable>
            </div>
        </div>
    );
}

export default EDSCompAssignment;